import { FileOutlined, Image, PDFOutlined, Video } from '@pay-com/icons'
import { SVGProps } from 'react'

type FilePreviewIconProps = {
  contentType?: string
} & SVGProps<SVGSVGElement>

export const FilePreviewIcon = ({
  contentType,
  ...props
}: FilePreviewIconProps) => {
  const type = contentType?.split('/')[0]

  switch (type) {
    case 'image':
      return <Image {...props} />
    case 'video':
      return <Video {...props} />
    case 'application':
      return <PDFOutlined {...props} />
    default:
      return <FileOutlined {...props} />
  }
}
